module.exports = __webpack_public_path__ + "img/vertical-logo.a26bf8a6.svg";